import { render, staticRenderFns } from "./RecoverForm.vue?vue&type=template&id=589ec5a2&scoped=true"
import script from "./RecoverForm.vue?vue&type=script&lang=js"
export * from "./RecoverForm.vue?vue&type=script&lang=js"
import style0 from "./RecoverForm.vue?vue&type=style&index=0&id=589ec5a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ec5a2",
  null
  
)

export default component.exports